import React, { useState } from 'react';
import cert1 from '../assets/certificate1.jpeg';
import cert2 from '../assets/certificate2.jpeg';

const Certifications = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const openModal = (img) => {
    setSelectedImg(img);
    // Optional: Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImg(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="container fitness d-sm-block d-none mt-5">
      <h3 className="coach text-center">Certifications</h3>

      <div className="certification-images d-flex justify-content-center align-items-center gap-4 mt-3">
        {/* Certificate 1 */}
        <div onClick={() => openModal(cert1)} style={{ cursor: 'pointer' }}>
          <img 
            src={cert1} 
            alt="Certification 1" 
            className="cert-img cert-img-normal"
          />
        </div>

        {/* Certificate 2 */}
        <div onClick={() => openModal(cert2)} style={{ cursor: 'pointer' }}>
          <img 
            src={cert2} 
            alt="Certification 2" 
            className="cert-img cert-img-horizontal"
          />
        </div>
      </div>

      {/* --- Lightbox Modal --- */}
      {selectedImg && (
        <div 
          className="cert-modal-overlay"
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            cursor: 'zoom-out'
          }}
        >
          {/* Close Button */}
          <span style={{
            position: 'absolute',
            top: '20px',
            right: '30px',
            color: 'white',
            fontSize: '40px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}>&times;</span>

          <img 
            src={selectedImg} 
            alt="Enlarged Certification" 
            style={{ 
              maxHeight: '90vh', 
              maxWidth: '90vw',
              borderRadius: '8px',
              boxShadow: '0 0 20px rgba(255,255,255,0.2)'
            }} 
            onClick={(e) => e.stopPropagation()} // Prevents closing when clicking the image itself
          />
        </div>
      )}
    </div>
  );
};

export default Certifications;